import * as React from 'react';


const Lastcrumb =  {
  name: ''
};

export default Lastcrumb;
